import enLocale from "element-ui/lib/locale/lang/en"; //引入element语言包
import enUS from "vxe-table/lib/locale/lang/en-US"; // 英语(美国)

const en = {
  message: {
    button: {
      generateItemNumber: "Generate Number",
      upgradeRevchangeMfrGenNumber: "New Rev,MFR,Number",
      generateCodeNumber: "Generate Number",
      upgradeSequence: "Upgrade Sequence",
      upgradeRev: "Upgrade Rev",
      changeManufacture: "Change Manufacture",
      save: "Save",
      delete: "Delete",
      deleteForm: "Delete Form",
      Undo: "Undo",
      cancel: "Cancel",
      clearSelected: "Clear Selected",
      clear: "Clear",
      replace: "Replace",
      add: "Add",
      edit: "Edit",
      affirm: "Yes",
      import: "Import",
      download: "Download",
      preview: "Preview",
      export: "Export",
      exportAll: "Export All",
      Creat: "Creat New",
      actions: "Actions",
      comment: "Comment",
      details: "Details",
      reset: "Reset",
      importRemak: "Import Remark",
      create: "Create",
      createNow: "Save",
      search: "Search",
      simpleSearch: "Simple Search",
      advancedSearch: "Advanced Search",
      bookmark: "Bookmark",
      cancelBookmark: "Cancel Bookmark",
      pause: "Pause",
      cancelPause: "Cancel Pause",
      cancel: "Cancel",
      createChange: "Create Change",
      release: "Release",
      submit: "Submit",
      whereUsed: "Where Used",
      PGWhereUsed: "Pending Changes Where Used",
      next: "Next",
      exportModel: "Export Template",
      done: "Done",
      toImport: "Import",
      check: "Check",
      order: "Order",
      authorize: "Authorize",
      import: "Import",
      confirmSetting: "Confirm Setting",
      saveAs: "Save As",
      return: "Return",
      calculateScore: "Calculate score",
      effect: "take effect",
      invalid: "invalid",
      projectStatus: "Project Status",
      cancelCode: "cancel code",
      BOMshow: "Show the first layer BOM",
      ProductDataQuery: "ProductData Query",
      taskstatement: "Task Query",
      executorstatement: "Execution Progress",
      remark: "Plan Remarks",
      testLink: "Test connectiv",
      downloadAttachment: "Deliverable Download",
      list: "List",
      state: "State",
      type: "Type",
      members: "Members",
      copyBOM: "copyBOM",
      stcokQuery: "Stcok Query",
      gantt: "Gantt",
      createCAPA: "Create CAPA",
      previousPage: "previous",
      nextPage: "next",
      TreeView: "Tree View",

      fill: "Fill",
      expandAll: "Expand All",
      payload: "Project Payload",
      startDate: "Start Date",
      endDate: "End Date",
      selectUser: "Select User",
      selectRange: "Selet Range",
      createItemQuality: "Create Quality",

      assignRoles: "Assign Roles",
      removenRoles: "Remove Roles",
      authorize: "Authorize",
      authShift: "Authorization Transfer",

      print: "Print",
      copy: "Copy",
      paste: "Paste",
      upFill: "Up Fill",
      downFill: "Down Fill",
      expand: "expand",
      close: "close",

      RegenerateXML: "Regenerate XML File",
      exportExcel: "Export Excel",
      restoreChange: " Restore Change Status",

      closeProject: "Close",
    },
    title: {
      globalSearch: "Global Search",
      personalSearch: "Personal Search",
      noPendingItem: "No Pending Item",
      readAndAgree: "I have read them carefully and agree ",
      addApprover: "Approvers",
      addObserver: "Observers",
      annotation: "Comments",
      userLogin: "User Login",
      login: "Login",

      checked: "checked",
      Checked: "Checked ",

      OverallStatus: "Overall Status",
      ScheduleStatus: "Schedule Status",
      CostStatus: "Cost Status",
      ResourceStatus: "Resource Status",
      TreeView: "Tree View",

      emptyText: "no data",
      emptyTextInAttachment:
        "Please drag the file/ folder to the table area to upload, or upload by clicking the add button",
      allFilter: "All",

      initial: "Introductory",

      welcome: "Welcome",
      releaseFlow: "The Release Flow Path",
      workflow: "workflow",
      addForStatus: "Add for Status",
      editAP_OB: "Edit Approver and Observer",
      addAP_OB: "Add Approver and Observer",
      searchUser: "Search User",
      addStatus: "Add Status",
      approver: "Approver",
      observer: "Observer",
      comments: "Comments",
      workflowExport: "workflow.xlsx",
      BOMdoc: "BOM.xlsx",
      importRelationshipTemplate: "importRelationship.xlsx",
      importMfrpTemplate: "importMfrp.xlsx",

      manualNextStatus: "Next Status",

      check: "Check",
      approveRelease: "Approve Release",
      approve: "Approve",
      rejectRelease: "Reject Release",
      reject: "Reject",
      finish: "Finish",
      checkStatus: "Check Status",
      checkResult: "Result",
      fileName: "File Name",
      importDate: "Import Date",

      error: "Error",
      warning: "Warning",

      search: "Search",
      quickSearch: "Quick Search",
      advancedSearch: "Advanced Search",
      searchCriteria: "Search Criteria",
      searchResult: "Search Result",
      totalResults: "Total Results ",
      resultsNums: "",
      missingRows: "not show no priviledge results.",
      searchUnit: "",

      aboutUs: "About Us",
      studyOnline: "Study Online",
      serviceOnline: "Service Online",
      changePW: "Chang Password",
      logout: "Logout",
      userSetting: "Personal settings",
      isPreemptive: "One person approve",
      viewTool: "View Tool",

      importFile: "Import Object(s)",
      importBOM: "Import BOM",
      fileModel: "Template File",
      fileImport: "Import File",
      isGenerateCodeNumber: "Is generate code number",
      importgeneralBOM: "BOM general template import",
      ImportPlanRemarks: "Import project Plan Remarks",
      importRelationship: "Import Relationships",
      importMfrp: "Import Manufacturer Parts",
      projectSchedule: "Project Schedule Preview",
      projectScheduleReports: "Project Query",

      // myProject:'Projects',
      myProcess: "My Process",
      myDashboard: "My Dashboard",
      myProject: "Projects",
      myAgent: "Tasks",
      myNotice: "My Notice",

      componentLibrary: "Component Library",

      myPriority: "My Priority",
      myTracing: "My Tracing ",
      mySubmit: "My Submit",
      changeNotice: "Change Notice",
      setting: "Setting",
      priorityChange: "Priority Change",
      participationChange: "Participation Change",
      submittedChange: "Submitted Change",
      cover: "Cover",
      affectedModel: "Affected Model",
      workflow: "Workflow",
      summary: "Summary",
      history: "History",
      manufacturer: "Manufacturer",
      titleBlock: "Title Block",

      approve: "Approve",
      reject: "Reject",
      add: "Add",
      changeObject: "Affected Items",

      currentVolume: "Current Volume",
      dilation: "Dilation",

      rev: "Rev.",
      BatchImportDoc: "Batch Import of Drawings/Documents",

      createFolder: "Please create the corresponding folder",
      saveNode: "Save",
      inheritBOM: "Whether to inherit BOM",

      create: "Create",
      createModel: "Create Model",
      createList: "Create List",
      createChange: "Create Change",
      createManufacturer: "Create Manufacturer",
      createManufacturerPart: "Create ManufacturerPart",
      quickCreate: "Quick Create",

      createWorkflow: "Create Workflow",
      User: "Search",

      baseInfo: "General Information",
      listVal: "List",
      listWhereUsed: "Where Used",

      pageOne: "Page One",
      pageTwo: "Page Two",
      pageThree: "Page Three",

      relationship: "Relationship",
      manufacturer: "Manufacturer",
      attachment: "Attachment",
      itemAttachment: "Item Attachment",
      list: "List",
      preferences: "Preferences",
      whereUsed: "Where Used",
      PGWhereUsed: "Pending Changes Where Used",
      pendingChange: "Pending Change",
      releasedChange: "Released Change",
      deliverables: "deliverables",

      addRole: "Add Role",
      editRole: "Edit Role",
      saveAs: "Save As",

      addPrivilege: "Add Privilege",
      editPrivilege: "Edit Privilege",
      autoNumber: "Auto Number",
      autoNumber2: "Auto Number",
      userGroup: "UserGroup",

      changeStatusTo: "Change Status To ",
      emailSetting: "Email Setting",
      IntegrationSetting: "Integration Setting",
      EmailServiceSettings: "Email Service Settings",
      IntegrationHost: "Integration Server",
      IntegrationPost: "Port number",
      IntegrationUser: "Integration Accounts",
      IntegrationPassWord: "Integration PassWord",
      preference: "Preference",
      emailHost: "Mailbox Server",
      emailPost: "Port number",
      emailUser: "Email Accounts",
      emailPassWord: "Email PassWord",
      selectTemplate: "Select Template",
      resourceMapping: "ResourceMapping",
      code: "code",
      codeInstructions: "Code Instructions",
      des: "Description",
      codeObject: "Select code subclass",
      defineCodePro: "Selcet code attributes",
      proNormalState: "Normal state",
      prosuspended: "Project to suspend",
      proShutDown: "Project closure",
      tasknormal: "Normal",
      taskOverdue: "Will be overdue",
      taskDelay: "More than expected",
      taskSuspended: "Suspended",
      taskClose: "Closed",
      rootName: "Root Name",
      firstLayerProjectName: "First Layer ProjectName",
      parentName: "Parent Name",
      proName: "ProName",
      type: "Type",
      startTime: "	StartTime",
      endTime: "EndTime",
      createTime: "CreateTime",
      overdueDays: "Overdue Days",
      principal: "Principal",
      redLine: "redLine",

      BOMCompare: "BOM Compare",
      PurchaseList: "Purchase List",
      BOMGather: "BOM Gather",

      priority: "Priority",
      inProcess: "in Process",
      completed: "Completed",
      searchName: "Search Name",

      searchSave: "Search and save",
      searchType: "Search Type",

      AppId: "AppId",
      CorpId: "CorpId",
      CorpSecret: "CorpSecret",

      authorize: "Authorize",
      folder: "Folder",

      allFields: "All",
      startDate: "Start Date",
      endDate: "End Date",
      replacedResources: "Replaced Resources",
      replaced: "Replaced For",

      WeCom: "We Com",
      Dingding: "Ding Ding",
      CreateNewScheduledTasks: "Create a new scheduled task",
      inbox: "INBOX",
      read: "READ",
      unread: "UNREAD",
      readEmails: "Read Emails",
      unreadEmails: "Unread Emails",
    },
    placeholder: {
      companyName: "Company Name",
      userName: "User Name",
      PW: "PassWord",
      search: "Search",
      input: "Input",
      select: "Select",
      pickDate: "Pick Date And Time",
      selectAttribute: "Select Attribute",
      selectOperator: "Select Operator",
      datePick: "Please pick a date",
      startDate: "Start Date",
      endDate: "End Date",
      project: "Project",
      state: "State",
      stateType: "StateType",
      lateType: "LateType",
      keyword: "keyword",

      //定时任务
      PleaseEnterTheTaskName: "Please enter the task name",
      PleaseEnterTaskDescription: "Please enter task description",
      PleaseSelectExecutionCycle: "Please select the execution cycle",
      PleaseSelectExecutionWeek: "Please select the execution week",
      PleaseSelectTime: "Please select a time",
      PleaseChooseNotificationMethod: "Please choose a notification method",
      PleaseChooseEnableOption: "Please choose whether to enable or not",
      PleaseEnterTheRecipientEmailAddress:
        "Please enter the recipient's email address",
      PleaseEnterTheCCRecipientEmailAddress:
        "Please enter the cc recipient's email address",
    },
    success: {
      upLoad: "Upload successful",
      downLoad: "Download successful",
      save: "Save Success",
      changePW: "Change Password Successfully",
      delete: "Delete Success",
      addFavoriteSuccessfully: "Add favorite successfully",
      removeFavoriteSuccessfully: "Remove favorite successfully",
      actions: "Successful action",
      emailRead: "The current email has been marked as read",
    },
    error: {
      workflowNotNull: "Workflow can not be empty",
      commonServerError: "Error, please contact administrator.",
      pickBaseClass: "Please select BaseClass.",
      cantModify: "Already used, can not modify.",
      cantDelete: "Already used, can not delete.",
      rejectNoComments: "Please provide reject reason.",
      noChange: "No value changed, no need save.",
      change: "Change Failed",
      notSame: "Password and confirm password should be same",
      nameRepeat: "Duplicate name entered",
      save: "Save Failed",
      name: "Name is required",
      performanceNum: "FormCode is required",
      rejectToStatus: "Please set reject to status",
      invalidedrejectToStatus:
        "Please make sure reject to status in the next status list.",
      type: "Type is required",
      input: "Input is required",
      search: "Search failed",
      pending: "Pending can not be deleted",
      addSame: "Add Faild: Can not add the same user again",
      sameUser: "Can not add the confirm user",
      same: "Can not add the same Manufacturer Part",
      add: "Add Failed",
      delete: "Delete Failed",
      assginRoles: "Assgin Roles Failed",
      privilegeAdd: "Privilege Add Failed",
      privilegeLoad: "Privilege Load Failed",
      privilegeUser: "Has No Privilege",
      assginRoles: "Assgin Roles Failed",
      noEdit: "Can not edit",
      deleteData: "Some data cannot be deleted,please choice again",
      unDoData: "Some data cannot be unDo,please choice again",
      loadAP_OB: "Load Approver and Observer Failed",
      approve: "Approver Failed",
      reject: "Reject Failed",
      param: "Parameter format not correct",
      emailHost: "The mailbox server cannot be empty",
      emailAccounts: "Please enter email accounts",
      emailAddress: "Please enter the correct email address",
      emailPassWord: "The password cannot be empty",
      IntegrationHost: "The Integration server cannot be empty",
      IntegrationAccounts: "Please enter Integration System accounts",
      // IntegrationAddress: 'Please enter the correct email address',
      IntegrationPassWord: "The password cannot be empty",
      post: "Port number cannot be empty and number",
      nameUsed: "The name has been used",
      autoNumLength:
        "The starting number length should be less than the number length, please edit again",
      autoNumLengthLessTen: "The number length should be less 10",
      disabledUser: "This user has been suspended",
      pleaseDisable: "Please disable it.",
      userMustOne:
        "The process has been executed, and the executor must have one",
      onlyOneOrTwo:
        "Only one or two pieces of data can be selected for comparison",
      codeValueLength: "Please fill in the number length",

      selectOneExecutor: "Please select the executor to be replaced",
      onlyOneExecutor: "You can only select one executor",
    },
    tips: {
      alreadyLastPage: "Already on the last page",
      alreadyFirstPage: "Already on the top page",
      intervalTooShort: "Query interval is too short",
      notFind: "Not found",
      searching: "Searching",
      upLoad:
        "Do not turn it off! The file is being uploaded. Please wait patiently",
      closeUpLoad: "Do you want to upload in the background?",
      downLoad:
        "Do not turn it off! The file is downloading, please wait patiently",
      noData: "No data",
      terms:
        "Please read carefully and agree 《杰信云隐私政策》, 《杰信云用户协议》",
      dataEnd: "The data is in the end!",
      dele_data: "Please select the data to be deleted",
      companyName: "Please input the companyname",
      userName: "Please input the username",
      PW: "Please input the password",

      tip: "Tip",
      name: "Please input name",
      saveCancel: "Save Cancel",
      closeSucess: "Sucess",
      tab: "There must have one tab at least",
      exportModel: 'Click for the "Object Import" operation manual',
      exportBom: 'Click for the "BOM Import" operation manual',
      Copyright: "Copyright © ,WuXiJieXin. All rights reserved.",
      // Copyright:
      //   "All rights reserved © Jiexin Software (Suzhou) Technology Co., Ltd. Su ICP No. 16064918-2",
      ClearCache: "Clear local cache",
      inputName: "Please Input Name",
      inputDes: "Please Input Description",
      changePW: "Change password successfully, please re-login.",
      reLogin: "please re-login.",
      cancel: "Canceled",

      noData: "no data",
      quickCreateTips:
        " Enter the keyword of the component to be created, click New, and then enter required properties.",

      workflow_101:
        "The following issues exist. You should resolve the errors first ",
      workflow_102: "You may continue when there are only warnings",
      workflow_103:
        "Select users to notify of the status change. If the next status is an approval status select reviewers.",

      exportModel:
        "Please export the model for the first use,and fill in according to the attribute order",
      inLinkage: "InLinkage",
      changeSubClass:
        "Changing the type may result in some data not being fully copied",
      requiredError:
        " Required fields cannot be left blank; the following required fields are blank",

      deleteCancel: "Cancel Delete",
      duplicateObject:
        "The following material with the same description already exists. Do you still want to proceed with creation?",

      saveCurrentRow: "Please save the current line first.",

      noDataForCurrent:
        "No product data available for the current type. Please create a new one.",

      del_01: "Please go to the parent plan page and delete this task.",

      selcetParentProject: "Please select a parent project",
      saveCurrentRow: "Please save the current line first",
      del_01: "Please navigate to the parent plan page and delete this task",
      add_01: "Subtasks cannot be added under this stage/milestone",
      add_02: "A stage/milestone cannot exist alone under this task",
      add_03:
        "The project/task has been completed, and no sub-tasks can be added",

      date_01:
        "The planned start date must not be later than the planned end date",
      date_02:
        "Under the current status, the plan start date must not be later than the task's planned start date",
      date_03:
        "Under the current status, the plan start date must not be earlier than the parent task's start date",
      date_04:
        "The planned end date must not be earlier than the planned start date",
      date_05:
        "Under the current status, the plan end date must not be earlier than the subtask's planned end date",
      date_06:
        "Under the current status, the plan end date must not be later than the parent plan's end date",

      item_mfc_tips: "The preferred status alternatives cannot be duplicated",

      // 'Please select a parent project before adding child items',
      // "Subtasks cannot be added under a stage/milestone",
      // "This project/task has been completed, and subtasks cannot be added.",
      // "A stage/milestone cannot be the only item under the current task.",
      // "The planned start date must not be later than the planned end date.",
      // "In the current state, the planned start date must not be later than the task's planned start date.",
      // "In the current state, the planned start date must not be earlier than the parent task's start date.",
    },
    confirm: {
      modifyCodeAttributes: "Do you want to update code attributes?",
      deleteSearch: "Are you sure to delete the search?",
      deleteData: "Are you sure to delete the record(s)?",
      deleteFormList: "Are you sure to delete the performance form?",
      cancelData: "Are you sure to close the project?",
      unDoData: "Are you sure to unDo the record(s)??",
      deleteList: "Are you sure to delete the record(s)?",
      deleteObject: "Are you sure to delete the object?",
      closeAllTabs: "Are you sure to close the other tabs?",
      clearSchedule: "Are you sure to clear the schedule?",
      logout: "Are you sure to logout?",
      close: "Are you sure to close?",
      msg_101: "",
      overwrite: "This file already exists, are you sure to overwrite it?",
      closeWithoutSave: "This page has not be saved, are you sure to leave?",
      hasSameItem:
        "There are some object has the same description, are you sure to continue?",
    },
    Auth: {
      authShift: "AuthCode",
      isAuth: "isAuth",
      authUser: "authUser",
      scope: "authScope",
    },
    table: {
      mouserSN: "Mouser field",
      mourserValue: "Mouser value",
      plmSN: "PLM field",
      manufacturer: "Manufacturer",
      address: "Address",
      name: "Name",
      baseInfo: "General Information",
      lifecyclephases: "Lifecycle Phases",
      mark: "User Interface Tabs",
      newSub: "New Subclass",
      fileResources: "File Resources",
      sysUser: "Systerm User",
      user: "User",
      group: "Group",
      userName: "User Name",
      userID: "User ID",
      roleName: "Role Name",
      projectName: "Name",
      des: "Description",
      status: "Status",
      type: "Type",
      displayType: "Display Type",
      codeValueLength: "Code Length",
      listType: "List Type",
      statusValue: "Status",
      actions: "Actions",
      privilege: "Privilege",
      privilegeType: "Privilege Type",
      criteria: "Criteria",
      classify: "Classify",
      dataType: "Data Type",
      workflow: "Workflow",
      startStatus: "Start Status",
      endStatus: "End Status",
      applied: "Applied",
      createDate: "Create Date",
      country: "Country",
      city: "City",
      isEnabled: "Enabled",
      statusVal_01: "Disabled",
      statusVal_02: "Enabled",

      numberLength: "Number of Characters",
      startNumber: "Starting Number",
      prefix: "Prefix",
      suffix: "Suffix",
      nextAutoNumber: "Next Number",

      number_: "Number",
      changeDes: "Change Description",
      changeStatus: "Change Status",

      enabled: "Enabled",
      disabled: "Disabled",

      enabled_01: "Enabled",
      disabled_01: "Disabled",

      simple: "Simple",
      cascade: "Cascade",
      dynamic: "Dynamic",
      code: "code",
      serialNumber: "serialNumber",
      versionNumber: "versionNumber",
      reference: "reference",
      SN: "Serial Number",

      list: "List",
      search: "Search",
      nextStatus: "next Status",
      entryReq: "Entry Required Fields",
      exitReq: "Exit Required Fields",
      ifReject: "If Reject, set Status to",
      approver: "Approvers",
      observer: "Observers",
      listOrder: "List Order",

      required: "Required",
      visible: "Visible",

      yes: "Yes",
      no: "No",
      none: "None",

      selectStartOrEnd: "Please select the start time / end time",
      templateName: "Template Name",
      copyRelate: "Copy Related Person Or Not",
      currency: "RMB",

      relatedOldDoc: "Link to Old Drawing Number",

      order: "Order",
      property: "Property",
      class: "Class",
      tab: "Tab",

      PW: "Password",
      PWagain: "Password Again",
      oldPW: "Old Password",
      newPW: "New Password",
      newPWagain: "New Password Again",
      PWnotSame: "Password and confirm password should be same",

      pageThree: "Page Three",
      title: "title:",

      text: "Text",
      textarea: "Textarea",
      selectList: "List",
      multilist: "Multilist",
      date: "Date",
      number: "Number",
      richText: "Rich Text",
      money: "Money",
      defaultValue: "Default value",
      placeholder: "Placeholder",
      weightOfKey: "The Weight Of Key Project",
      weightOfNonKey: "The Weight Of Non_key Project",
      autoVersion: "Automatic version generation",
      isVerify: "Actual Time Check",
      exportChange: "Export release changes",
      cancelAll: "CancelAll",
      more: "More",
      all: "All",
      linkage: "Linkage",

      folder: "Folder",

      rejected: "Rejected",
      submitDate: "Submit Date",
      createdDate: "Created Date",
      completedDate: "Completed Date",

      //定时任务字段
      taskName: "TASK Name",
      taskDescription: "Task Description",
      taskStatus: "Task Status",
      objectType: "Object Type",
      dataStatisticalObject: "Data Statistical Object",
      executeCycle: "Execution Cycle",
      executionWeek: "Execution Week",
      executeTime: "Execution Time",
      notificationMethod: "Notification Method",
      recipient: "Recipient",
      cc: "CcRecipient",
      //收件箱
      theme: "Theme",
      sender: "Sender",
      sentTime: "Sent Time",
    },
    warning: {
      alreadyInPersonalSearch: "Existing in personal search list",
      alreadyInFavorite: "Existing in favirate list",
      searchErr_01: "the search criteria can not be empty",
      searchErr_02: "the result is empty",
      blankRequired: "Required field(s) cannot be blank!",
      substituteTissueRelNotOneBlank:
        "Please check the values of Substitute Tissue and Substitute Relation attributes",

      length_101: "Length should be 3 to 25",
      length_102: "Length should be 5 to 20",
      length_103: "Length should be 1 to 200",
      length_104: "Length should be 5 to 15",
      length_105: "Length should be 1 to 18",
      length_106: "Length should be 3 to 18",
      length_107: "Length should be 3 to 40",
      length_108: "Length should be 5 to 40",

      nameRequired: "Name is Required",
      inputPW: "Please Input Password",
      required: "This input is required",
      choice: "Only one choice",
      name: "Name is Required",
      PW: "Password is Required",
      PWLength: "Length should be 3 to 60",
      confirmPW: "Password is Required",
    },
    workflowType: {
      Pending: "Pending",
      Submit: "Submit",
      Review: "Review",
      Released: "Released",
      Complete: "Complete",
      Cancel: "Cancel",
      Hold: "Hold",

      w_101: "Please select workflow first",
    },

    ppmWorkflowType: {
      Pending: "Pending",
      Progress: "Progress",
      Complete: "Complete",
      Reject: "Reject",
      w_101: "Please select workflow first",
    },

    transform: {
      choices: "Choices",
      selected: "Selected",

      assignRoles: "Assign Roles",
    },

    list: {
      baseInfo: "General Information",
      pageOne: "Page One",
      pageTwo: "Page Two",
      pageThree: "Page Three",
      pendingChange: "Pending Change",
      changeHistory: "Change History",
      BOM: "BOM",
      manufacturer: "Manufacturer",
      attachment: "Attachment",
      itemAttachment: "Item Attachment",
      whereUsed: "Where Used",
      pendingChangeWhereUsed: "Pending Change WhereUsed",
      relationship: "Relationship",
      historyRecord: "History",
      affectedObjects: "Affected Objects",
      preferences: "Preferences",
      userGroup: "UserGroup",
      user: "User",
      schedule: "Schedule",
      deliverables: "deliverables",
      team: "team",
      scheduleComments: "Schedule Comments",
      scheduleCommentsTemplate: "Schedule Comments Template",
      relatedItem: "RelatedItem",
      relatedResource: "RelatedResource/ResourceGroup",
      owningResource: "OwningResource",
      owningTechnology: "OwningTechnology",
      itemRelatedTechnology: "Technology",
      itemQuality: "Quality",
      questionObject: "QuestionObject",
      associateTheSameForm: "AssociateTheSameForm",

      showAttribute: "Show Attribute",
      showAttributeName: "Show Attribute Name",
      itemQuality: "Quality",

      Separator: "Separator",
      duplicateType: "This type already exists",
    },
    operatorGroup: {
      IsNull: "Is Empty",
      IsNotNull: "Is Not Empty",
      EqualTo: "Equal To",
      NotEqualTo: "Not Equal To",
      Like: "Like",
      NotLike: "Not Like",
      Contains: "Contains",
      DoesNotContains: "Does Not Contains",
      StartsWith: "Starts With",
      DoesNotStartsWith: "Does Not Starts With",
      Between: "In",
      NotBetween: "Not In",
      Between_DM: "Between",
      NotBetween_DM: "Not Between",
      ContainsAny: "Contains Any",
      ContainsAll: "Contains All",
      ContainsNone: "Contains None",
      GreatThan: "Great Than",
      GreatThanOrEqualTo: "Great Than Or Equal To",
      LessThan: "Less Than",
      LessThanOrEqualTo: "Less Than Or Equal To",

      and: "And",
      or: "Or",
    },
    performance: {
      firstTitle: "Personal performance appraisal form (main form)",
      secondTitle: "Project performance (sub table)",
      scoreData: "Comprehensive scoring of project performance",
      otherScoreData: "Other non project assessment scores",
      HrScoreData: "Department and HR assessment scoring",
      formNumber: "Form number",
      formName: "Form name",
      jobNumber: "Job number",
      name: "name",
      Department: "Department",
      assessmentDate: "Assessment date",
      documentDate: "Document date",
      preparer: "Preparer",
      keyProjects: "Scoring of key projects",
      noKeyProjects: "Scoring of non key projects",
      assessor: "Assessor",
      otherAssessment: "Other assessment",
      performanceScoreData: "Work log scoring",
      performanceHrScoreData: "5S Scoring",
      description: "Description",
      performanceScore: "Comprehensive performance appraisal score",
      keyProject: "Key Project/Task",
      projectManager: "Manager",
    },
    agent: {
      principal: "Principal",
      projectManager: "ProjectLeader",
      observer: "Observer",
      executors: "Executors",
    },
    titleBlockImg: {
      bigImg: "Pictures can be uploaded up to 4MB, please upload again!",
      notImg:
        "Only picture format files are supported(jpg,jpeg,gif,png,bmp), please upload again!",
    },
    calendar: {
      currentYear: "The current year",
      year: "Year",
      month: "Month",
      day: "Day",
      week: "Week",
      season: "Quarterly",
    },
    // list:{
    //   baseInfo:'General Information',
    // }
  },
  ...enLocale,
  ...enUS,
};

export default en;
